import { Object3D } from 'three'

export const buriedMinion = async (obj: Object3D) => {
  obj.position.y = -2
}
